import {Component, forwardRef, Input} from '@angular/core';
import {Good, Partner} from '@app/shared';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-avatar-select',
  standalone: false,

  templateUrl: './avatar-select.component.html',
  styleUrl: './avatar-select.component.less',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AvatarSelectComponent),
      multi: true,
    },
  ],
})
export class AvatarSelectComponent {
  @Input() options: any[] = [];
  @Input() urlProperty: string = 'avatar';
  @Input() labelProperties: string[] = ['name', 'surName'];
  @Input() placeholder = 'Selecciona una opción...';
  @Input() showPartnerIcon = true;
  @Input() isCurrency = false;

  value: number | null = null;
  disabled = false;

  onChange = (value: number | null) => {
  };
  onTouched = () => {
  };

  writeValue(value: number | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(value: number | null): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  getPartner(id: number): Partner {
    const optionList: any[] = this.options || [];
    return optionList.find(p => p.id === id)!;
  }
}
